import Vue from 'vue'
import VueRouter from 'vue-router'


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    alias: '登录',
    component: () => import('@/views/login.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/index',
    name: 'index',
    alias: '首页',
    component: () => import('@/views/index.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/exhibitor',
    name: 'exhibitor',
    alias: '展商认证',
    component: () => import('@/views/exhibitor.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/conference',
    name: 'conference',
    alias: '会刊信息',
    component: () => import('@/views/conference.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/busInformation',
    name: 'busInformation',
    alias: '企业信息',
    component: () => import('@/views/busInformation.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/productList',
    name: 'productList',
    alias: '产品管理',
    component: () => import('@/views/productList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/exbadgeList',
    name: 'exbadgeList',
    alias: '展商胸卡',
    component: () => import('@/views/exbadgeList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/badgeList',
    name: 'badgeList',
    alias: '客户胸卡',
    component: () => import('@/views/badgeList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/createProduct',
    name: 'createProduct',
    alias: '创建产品',
    component: () => import('@/views/createProduct.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/exhibitorManual',
    name: 'exhibitorManual',
    alias: '展商手册',
    component: () => import('@/views/exhibitorManual.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/shellScheme',
    name: 'shellScheme',
    alias: '展位准备标摊',
    component: () => import('@/views/shellScheme.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/standPrepare',
    name: 'standPrepare',
    alias: '展位准备',
    component: () => import('@/views/standPrepare.vue'),
    meta: {
      isLogin: true
    }
  },

  {
    path: '/diyPoster',
    name: 'diyPoster',
    alias: '自定义邀请函',
    component: () => import('@/views/diyPoster.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/attestation',
    name: 'attestation',
    alias: '展商实名认证',
    component: () => import('@/views/attestation.vue'),
    meta: {
      isLogin: true
    }
  },

  {
    path: '/contactPerson',
    name: 'contactPerson',
    alias: '联系人',
    component: () => import('@/views/contactPerson.vue'),
    meta: {
      isLogin: true
    }
  },

  {
    path: '/services',
    name: 'services',
    alias: '免费宣传服务',
    component: () => import('@/views/services.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/aptitude',
    name: 'aptitude',
    alias: '企业资质及发票',
    component: () => import('@/views/aptitude.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    alias: '已签订协议',
    component: () => import('@/views/agreement.vue'),
    meta: {
      isLogin: true
    }
  },

  {
    path: '/reservation',
    name: 'reservation',
    alias: '酒店预定',
    component: () => import('@/views/reservation.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/businesslicense',
    name: 'businesslicense',
    alias: '营业执照',
    component: () => import('@/views/businesslicense.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/property',
    name: 'property',
    alias: '产品知识产权',
    component: () => import('@/views/property.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/invoice',
    name: 'invoice',
    alias: '发票',
    component: () => import('@/views/invoice.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/introduce',
    name: 'introduce',
    alias: '宣传介绍',
    component: () => import('@/views/introduce.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/recruit',
    name: 'recruit',
    alias: '企业招聘信息',
    component: () => import('@/views/recruit.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/discussionindex',
    name: 'discussionindex',
    alias: '评奖系统首页',
    component: () => import('@/views/discussion/discussionindex.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/awardsDetail',
    name: 'awardsDetail',
    alias: '评奖系统详情',
    component: () => import('@/views/discussion/awardsDetail.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/enterpriseAward',
    name: 'enterpriseAward',
    alias: '品牌企业评奖',
    component: () => import('@/views/discussion/enterpriseAward.vue'),
    meta: {
      isLogin: true
    }
  },

  {
    path: '/productawardList',
    name: 'productawardList',
    alias: '产品列表',
    component: () => import('@/views/discussion/productawardList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/addproductList',
    name: 'addproductList',
    alias: '新增产品',
    component: () => import('@/views/discussion/addproductList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/productawardForm',
    name: 'productawardForm',
    alias: '编辑产品',
    component: () => import('@/views/discussion/productawardForm.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/productawardDetail',
    name: 'productawardDetail',
    alias: '产品详情',
    component: () => import('@/views/discussion/productawardDetail.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/invitation',
    name: 'invitation',
    alias: '邀请管理',
    component: () => import('@/views/invitation.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/invitationGuest',
    name: 'invitationGuest',
    alias: '邀请',
    component: () => import('@/views/invitationGuest.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/liveList',
    name: 'liveList',
    alias: '直播管理',
    component: () => import('@/views/liveList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/liveSet',
    name: 'liveSet',
    alias: '直播设置',
    component: () => import('@/views/liveSet.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/visitorView',
    name: 'visitorView',
    alias: '访客查看',
    component: () => import('@/views/visitorView.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/inquiryList',
    name: 'inquiryList',
    alias: '预约询盘',
    component: () => import('@/views/inquiryList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/scan',
    name: 'scan',
    alias: '扫一扫',
    component: () => import('@/views/scan.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/scanSuccess',
    name: 'scanSuccess',
    alias: '扫一扫',
    component: () => import('@/views/scanSuccess.vue'),
    meta: {
      isLogin: true
    }
  },
  
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
